/* Countdown / pre-launch page */
(function () {
  'use strict';

  var root = document.querySelector('[data-drop]');
  if (!root) return;

  /* ---------- Popups ---------- */

  var lastFocus = null;

  function openModal(modal) {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    document.documentElement.classList.add('modal-open');
    setTimeout(function () {
      var f = modal.querySelector('input:not([disabled]):not([type="hidden"]), button[type="submit"]:not([disabled])');
      if (f) f.focus();
    }, 60);
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    if (!root.querySelector('.modal.is-open')) {
      document.documentElement.classList.remove('modal-open');
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.querySelectorAll('[data-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openModal(document.getElementById(btn.getAttribute('data-open')));
    });
  });

  root.querySelectorAll('[data-modal]').forEach(function (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-close]')) closeModal(modal);
    });
  });

  document.addEventListener('keydown', function (e) {
    var open = root.querySelector('.modal.is-open');
    if (!open) return;

    if (e.key === 'Escape') { closeModal(open); return; }

    if (e.key === 'Tab') {
      var items = open.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"])');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Re-open a popup after the page reloads with a result (success or error) */
  root.querySelectorAll('[data-open-on-load]').forEach(function (flag) {
    openModal(flag.closest('[data-modal]'));
  });

  /* ---------- SMS sign-up: checkbox first, then number ---------- */

  var sms = root.querySelector('[data-sms-form]');
  if (sms) {
    var box = sms.querySelector('[data-consent]');
    var phone = sms.querySelector('[data-phone]');
    var submit = sms.querySelector('[data-sms-submit]');

    if (box && phone && submit) {
      var sync = function () {
        phone.disabled = !box.checked;
        submit.disabled = !box.checked;
      };

      box.addEventListener('change', function () {
        sync();
        if (box.checked) phone.focus();
      });
      phone.addEventListener('input', function () { phone.setCustomValidity(''); });
      sync();

      sms.addEventListener('submit', function (e) {
        if (!box.checked) { e.preventDefault(); return; }

        var cc = (sms.getAttribute('data-cc') || '1').replace(/\D/g, '') || '1';
        var raw = phone.value.trim();
        var digits = raw.replace(/\D/g, '');
        var e164 = null;

        if (raw.charAt(0) === '+') e164 = '+' + digits;
        else if (digits.length === 10) e164 = '+' + cc + digits;
        else if (digits.length === cc.length + 10 && digits.indexOf(cc) === 0) e164 = '+' + digits;

        if (!e164 || e164.length < 11 || e164.length > 16) {
          e.preventDefault();
          phone.setCustomValidity('Enter a valid mobile number');
          phone.reportValidity();
          return;
        }

        phone.value = e164;

        /* Shopify's sign-up form insists on an email. We only collect numbers, so give it a
           stand-in address built from the number. It is never shown and never emailed. */
        var fake = sms.querySelector('[name="contact[email]"]');
        if (!fake) {
          fake = document.createElement('input');
          fake.type = 'hidden';
          fake.name = 'contact[email]';
          sms.appendChild(fake);
        }
        fake.value = 'sms-' + e164.replace(/\D/g, '') + '@example.com';

        var mk = sms.querySelector('[name="contact[accepts_marketing]"]');
        if (!mk) {
          mk = document.createElement('input');
          mk.type = 'hidden';
          mk.name = 'contact[accepts_marketing]';
          sms.appendChild(mk);
        }
        mk.value = 'false';
      });
    }
  }

  /* ---------- Early access password (homepage mode) ---------- */

  var D = window.Drop || {};
  var target = D.target;
  var isHome = root.classList.contains('drop--home');
  var html = document.documentElement;

  function unlock() {
    html.classList.remove('drop-locked');
    root.querySelectorAll('.modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    html.classList.remove('modal-open');
    window.scrollTo(0, 0);
  }

  var codeForm = root.querySelector('[data-code-form]');
  if (codeForm) {
    codeForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var want = (codeForm.getAttribute('data-code') || '').trim().toLowerCase();
      var got = (codeForm.elements.code.value || '').trim().toLowerCase();
      var msg = codeForm.querySelector('[data-code-msg]');
      if (want && got === want) {
        try { localStorage.setItem('drop-early', String(target)); } catch (err) {}
        unlock();
      } else if (msg) {
        msg.hidden = false;
      }
    });
  }

  /* ---------- Countdown ---------- */

  var cd = root.querySelector('[data-countdown]');
  if (!cd) return;

  /* Homepage: only count down while the countdown is actually showing */
  if (isHome && !html.classList.contains('drop-locked')) return;

  var redirectUrl = cd.getAttribute('data-redirect') || '/';
  var units = {
    d: cd.querySelector('[data-unit="d"]'),
    h: cd.querySelector('[data-unit="h"]'),
    m: cd.querySelector('[data-unit="m"]'),
    s: cd.querySelector('[data-unit="s"]')
  };

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function showInvalid() {
    var inv = root.querySelector('[data-invalid]');
    if (inv) inv.hidden = false;
  }

  /* Once only per session, so a still-locked store can't cause a reload loop */
  function once(key, ms) {
    var last = 0;
    try { last = Number(sessionStorage.getItem(key) || 0); } catch (e) { return false; }
    if (Date.now() - last <= ms) return false;
    try { sessionStorage.setItem(key, String(Date.now())); } catch (e) { return false; }
    return true;
  }

  function goLive() {
    if (isHome) {
      /* No "we're live" page: show the products straight away */
      unlock();
      if (once('drop-reloaded-' + target, 60000)) window.location.reload();
    } else if (root.getAttribute('data-autopass')) {
      /* Shopify password page: let the visitor in with the store password at drop time */
      var pwForm = root.querySelector('form[action*="password"]');
      var pwInput = pwForm && pwForm.querySelector('input[name="password"]');
      if (pwInput && once('drop-autopass', 60000)) {
        pwInput.value = root.getAttribute('data-autopass');
        pwForm.submit();
      }
    } else if (once('drop-redirected', 60000)) {
      window.location.href = redirectUrl;
    }
  }

  function tick() {
    if (isNaN(target)) { showInvalid(); return false; }

    var diff = target - Date.now();
    if (diff <= 0) { goLive(); return false; }

    var total = Math.floor(diff / 1000);
    units.d.textContent = pad(Math.floor(total / 86400));
    units.h.textContent = pad(Math.floor((total % 86400) / 3600));
    units.m.textContent = pad(Math.floor((total % 3600) / 60));
    units.s.textContent = pad(total % 60);
    return true;
  }

  if (tick()) {
    var timer = setInterval(function () {
      if (!tick()) clearInterval(timer);
    }, 1000);
  }
})();
